import { render, staticRenderFns } from "./ConsolidatePrize.vue?vue&type=template&id=795ced0e&"
import script from "./ConsolidatePrize.vue?vue&type=script&lang=js&"
export * from "./ConsolidatePrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('795ced0e')) {
      api.createRecord('795ced0e', component.options)
    } else {
      api.reload('795ced0e', component.options)
    }
    module.hot.accept("./ConsolidatePrize.vue?vue&type=template&id=795ced0e&", function () {
      api.rerender('795ced0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/components/ConsolidatePrize.vue"
export default component.exports